import getCurrentComponent from './getCurrentComponent';
import renderCMWrapper from './renderCMWrapper';

export default (
    oneComponent,
    index,
    cmCompleteComponentList,
    cmComponentsWithoutGrid,
    propsData,
    limitInitialComponentsRendered = null
) => {
    let customComponent = null;
    let componentDom = null;
    try {
        /* istanbul ignore else */
        customComponent = getCurrentComponent(oneComponent, index, cmCompleteComponentList);
        /* istanbul ignore else */
        if (customComponent) {
            componentDom = renderCMWrapper(
                customComponent.component,
                customComponent.props,
                customComponent.index,
                cmComponentsWithoutGrid,
                propsData,
                limitInitialComponentsRendered
            );
        } else {
            console.warn(
                'CM: Component name is not there in the export list',
                oneComponent.componentType
            );
        }
    } catch (e) /* istanbul ignore next */ {
        console.warn('CM: component name missmatch, check CM Response');
    }
    return componentDom;
};
